export default {"src":"/_next/static/image/components/ui/Icon/icons/email.a2d012fcf14b8365bfabce2a2d4bd658.svg","height":20,"width":20};